import React, { memo } from 'react'
import { useTranslate } from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'

const getIdsFromPaymentRecord = (record) => {
  if (record && record.payment) {
    if (record.payment.card && Array.isArray(record.payment.card) && record.payment.card.length > 0) {
      const {
        payment: { card },
      } = record
      return card.map((elem) => elem.id)
    }
  }
}

export const GetPaymentFields = memo(
  ({
    paymentTypes,
    loadingPaymentTypes,
    onChangePaymentType,
    paymentMethodsBank,
    loadingPaymentMethodsBank,
    onChangePaymentMethod,
    paymentMethodsCard,
    record = undefined,
    selectedPaymentMethodsBank = undefined,
    selectedPaymentMethodsCard = undefined,
    setSelectedPaymentMethodsCard = undefined,
    fullFields = false,
  }) => {
    const translate = useTranslate()

    return (
      <Grid container spacing={3}>
        <EditInputsWrap label={translate('ra.field.payment_type')}>
          {loadingPaymentTypes ? (
            <Skeleton variant='rectangular' width={'100%'} height={40} />
          ) : (
            <SelectInput
              source='payment.payment_type_id'
              options={paymentTypes}
              label=''
              optionsText={['short_name']}
              optionValue='id'
              multiple
              onChange={
                record
                  ? (e) => onChangePaymentType(paymentTypes, e.target.value)
                  : (e) => onChangePaymentType(e)
              }
              defaultValue={record ? getIdsFromPaymentRecord(record) : undefined}
            />
          )}
        </EditInputsWrap>
        {fullFields && (
          <>
            <EditInputsWrap label={translate('ra.field.payment_method_by_bank')}>
              {loadingPaymentMethodsBank ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='payment.payment_method_bank'
                  options={paymentMethodsBank}
                  optionsText={['long_name']}
                  onChange={
                    record
                      ? (e) => onChangePaymentMethod(paymentMethodsBank, e.target.value)
                      : (e) => onChangePaymentMethod(e)
                  }
                  multiple
                  defaultValue={selectedPaymentMethodsBank}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.payment_method')}>
              <SelectInput
                source='payment.payment_method_card'
                options={paymentMethodsCard}
                optionValue='customId'
                optionsText={['nameMethod', 'long_name']}
                multiple
                defaultValue={selectedPaymentMethodsCard}
                onChange={
                  setSelectedPaymentMethodsCard
                    ? (e) => setSelectedPaymentMethodsCard(e.target.value)
                    : undefined
                }
              />
            </EditInputsWrap>
          </>
        )}
      </Grid>
    )
  }
)
